import { render, staticRenderFns } from "./CoProprieteInfoPdf.vue?vue&type=template&id=23a30207&scoped=true&"
import script from "./CoProprieteInfoPdf.vue?vue&type=script&lang=js&"
export * from "./CoProprieteInfoPdf.vue?vue&type=script&lang=js&"
import style0 from "./CoProprieteInfoPdf.vue?vue&type=style&index=0&id=23a30207&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a30207",
  null
  
)

export default component.exports